import React from "react";
import "./Exitknown.css";
import { Link } from "react-router-dom";
import knownimage1 from "../Sliderimg/side1.avif";
import knownimage2 from "../Sliderimg/side3.avif";

const KnownUs = () => {
  return (
    <>
      <div className="cont">
        <div className="about_index">
          <div className="about_background_image"></div>
          <div className="about_index_para">
            <h1 className="product_title" style={{ color: "#30dcfeff", padding: "20px", textTransform: "uppercase", fontSize: "28px", lineHeight: "1.5" }}>Smart Software & Digital Solutions for Business Growth</h1>
            <h2 className="t1">
              <p className="pre" style={{ marginBottom: 20 }}>
                Know About
              </p>{" "}
              <strong style={{ color: "#FF635E", margin: "0" }}>
                Kitkat Software Technologies
              </strong>
            </h2>
            <p className="p1" style={{ marginTop: 20, marginBottom: 30 }}>
              KitKat Software Technologies specializes in delivering personalized digital solutions that support business growth in different sectors.
            </p>
            <p className="p1" style={{ marginBottom: 30 }}>
              Our expertise includes Web Development, Application Development, Creative Design, Quality Assurance, Banking Services, and Billing Software.
            </p>
            <p className="p1" style={{ marginBottom: 30 }}>
              {" "}
              We take time to understand each client’s specific requirements and business goals to provide solutions that truly support their growth. Our team builds custom, responsive websites that align with business objectives, ensuring seamless functionality and a user-friendly experience. We also offer ongoing maintenance and support services to keep your website secure, updated, and performing at its best.
            </p>
            <p className="p1_d" style={{ marginBottom: 30 }}>
              KitKat Software Technologies is dedicated to providing dependable, effective, and future-ready solutions for companies of all sizes by adopting a customer-focused strategy and having a strong love for innovation.
            </p>
            <p className="p1_d" style={{ marginBottom: 30 }}>
              Your website creates the first impression of your business in the digital world. That’s why we design websites that are informative, visually appealing, and easy to navigate. A professionally developed website strengthens your brand credibility and enhances user experience, helping convert visitors into customers.

            </p>{" "}
            <p className="p1_d" style={{ marginBottom: 30 }}>
              Selecting the right technology is essential for long-term success. Whether you need to improve your existing system or build a new solution, our experts provide effective strategies aligned with your business goals.

            </p>
            <p className="p1_d" style={{ marginBottom: 30 }}>
              We believe in involving our clients at every stage of the development process. By understanding your vision clearly, we ensure the final product meets your expectations. We follow modern development methodologies like Agile to ensure flexibility, collaboration, and continuous improvement.

            </p>

            <div style={{display:"flex" , justifyContent:"center", marginTop:"20px"}}>
              <Link  to="/about-us" className="rm">
                Read More
              </Link>
            </div>

          </div>

          <div className="about_index_image">
            <img src={knownimage1} alt="IOS Application" />
            <img src={knownimage2} alt="Windows Application" />
          </div>
        </div>
      </div>
    </>
  );
};
export default KnownUs;
